/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { IntegratedSearchAndNavLayout as Layout } from '../../layouts'
import fetchDatasetAction from '../../redux/api/fetchDataset'
import { getDatasetError, getSelectedDataset, getDatasetPending } from '../../redux/reducers/datasetReducer'

import AlertDialogSlide from "../../components/AlertDialogSlide";

import DatasetContainer from './DatasetContainer'

class DatasetPage extends Component {
    componentDidMount() {
        const { datasetId } = this.props.match.params
        console.log(datasetId)

        const { fetchDataset } = this.props
        fetchDataset(datasetId)
    }
    render() {
        const { classes, pending, selectedDataset, error } = this.props

        if (pending) {
            return (<Layout><div>loading</div></Layout>)
        } else if (!selectedDataset) {
            // return (<Layout><div>no dataset</div></Layout>)
            return (
                <Layout>
                    <AlertDialogSlide slideTitle="UNAUTHORIZED" slideMessage="You do not have access to this dataset"/>
                </Layout>)
        }

        return (
            <Layout>
                <DatasetContainer dataset={ selectedDataset } />
            </Layout>
        )
    }
}

DatasetPage.propTypes = {}
DatasetPage.defaultProps = {}

const mapStateToProps = state => ({
    error: getDatasetError(state),
    selectedDataset: getSelectedDataset(state),
    pending: getDatasetPending(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchDataset: datasetId => fetchDatasetAction(datasetId),
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DatasetPage)
